// Pure helpers for the hook edit form: the wire shape <-> form values, and
// the same content rules the backend enforces (backend/app/schemas/hooks.py) so the
// editor sees problems before saving. The server stays the authority.

export const QUESTION_MAX = 90;
export const OPTION_MAX = 16;
export const EXPLANATION_MAX = 160;
export const BRIDGE_MAX = 120;

export const EMPTY_FORM = {
    question: '',
    optionA: 'Yes',
    optionB: 'No',
    correctIndex: 0,
    explanation: '',
    bridge: '',
};

export function hookToForm(hook) {
    if (!hook) return { ...EMPTY_FORM };
    const options = hook.options || ['Yes', 'No'];
    return {
        question: hook.question || '',
        optionA: options[0] || '',
        optionB: options[1] || '',
        correctIndex: hook.correct_index === 1 ? 1 : 0,
        explanation: hook.explanation || '',
        bridge: hook.bridge || '',
    };
}

export function formToPayload(form) {
    const bridge = (form.bridge || '').trim();
    return {
        question: (form.question || '').trim(),
        options: [(form.optionA || '').trim(), (form.optionB || '').trim()],
        correct_index: form.correctIndex === 1 ? 1 : 0,
        explanation: (form.explanation || '').trim(),
        bridge: bridge || null,
    };
}

// Returns {field: message} for every rule the form breaks; {} when clean.
export function validateForm(form) {
    const errors = {};
    const question = (form.question || '').trim();
    if (!question) errors.question = 'Required';
    else if (question.length > QUESTION_MAX) errors.question = `At most ${QUESTION_MAX} characters`;
    else if (!question.endsWith('?')) errors.question = 'Must end with a question mark';

    [['optionA', form.optionA], ['optionB', form.optionB]].forEach(([key, raw]) => {
        const value = (raw || '').trim();
        if (!value) errors[key] = 'Required';
        else if (value.length > OPTION_MAX) errors[key] = `At most ${OPTION_MAX} characters`;
    });

    const explanation = (form.explanation || '').trim();
    if (!explanation) errors.explanation = 'Required';
    else if (explanation.length > EXPLANATION_MAX) errors.explanation = `At most ${EXPLANATION_MAX} characters`;

    if ((form.bridge || '').trim().length > BRIDGE_MAX) errors.bridge = `At most ${BRIDGE_MAX} characters`;
    return errors;
}

// What the app shows after a guess, for the live preview in the modal.
export function revealPreview(form, courseName) {
    const options = [form.optionA || '', form.optionB || ''];
    const answer = options[form.correctIndex === 1 ? 1 : 0] || '…';
    const explanation = (form.explanation || '').trim();
    const bridge = (form.bridge || '').trim();
    return {
        correct: `Spot on. The answer is ${answer}. ${explanation}`.trim(),
        incorrect: `Not quite. The answer is ${answer}. ${explanation}`.trim(),
        bridge: bridge || `And you can read the full story behind it in “${courseName || 'the course'}”`,
    };
}
